import React from "react";

interface FeatureTogglesContextValue {
  toggles: Record<string, boolean>;
  setToggle: (id: string, enabled: boolean) => void;
}

const FeatureTogglesContext = React.createContext<FeatureTogglesContextValue>({
  toggles: {},
  setToggle: () => undefined,
});

export const FeatureTogglesProvider = ({ children }) => {
  const [toggles, setToggles] = React.useState<Record<string, boolean>>({});

  const setToggle = React.useCallback((id: string, enabled: boolean) => {
    setToggles((prev) => ({ ...prev, [id]: enabled }));
  }, []);

  const value = React.useMemo(
    () => ({ toggles, setToggle }),
    [toggles, setToggle]
  );

  return (
    <FeatureTogglesContext.Provider value={value}>
      {children}
    </FeatureTogglesContext.Provider>
  );
};

export const useFeatureTogglesContext = () =>
  React.useContext(FeatureTogglesContext);

export default FeatureTogglesContext;
